


















































import Vue from 'vue'
import Component from 'vue-class-component'
import { OpenGraph, OpenGraphTypes, MetadataTranslation } from '@/modules/seo/types'
import ArticleEditor from '@/modules/seo/components/opengraph/ArticleEditor.vue'
import { Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import ProductEditor from '@/modules/seo/components/opengraph/ProductEditor.vue'

export interface OpenGraphComponentType {
  type: OpenGraphTypes
  name: string
  icon: string
  editor?: string
}

/**
 * Editor OpenGraph
 *
 * Muestra al usuario una pantalla donde puede modificar los atributos del
 * protocolo OpenGraph que serán mostrados a las redes sociales
 * mediante las etiquetas "meta"
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
  components: {
    'opengraph-article-editor': ArticleEditor,
    'opengraph-product-editor': ProductEditor,
  },
})
export default class OpenGraphEditor extends Vue {

  /**
   * Bloquear tipo
   *
   * Permite definir el único tipo de contenido OpenGraph permite utilizar.
   */
  @Prop({default: ''})
  public lockType: string

  @Prop({type: Boolean, default: false })
  public disabled: boolean

  @Prop({type: String, default: ''})
  public defaultType: string

  @Getter('seo/metadata/current/translation')
  public translation: MetadataTranslation

  /**
   * Retorna el tipo de contenido OpenGraph seleccionado por el usuario o el
   * forzado si el bloqueo esta activado
   */
  get type (): object | undefined  {
    const type = this.typeIsLocked ? this.lockType : this.opengraph.type
    return this.types.find(t => t.type === type)
  }

  get typeIsLocked (): boolean {
    return this.lockType !== ''
  }

  public setType (type: OpenGraphTypes) {
    const t = this.getType(type)
    if (!t) {
      throw new Error(`No existe el tipo de OpenGraph "${type}"`)
    }

    this.update('type', t.type)
  }

  /**
   * Busca un tipo de OpenGraph
   */
  public getType (type: OpenGraphTypes) {
      return this.types.find(componentType => {
          if (!componentType.type) {
              return false
          }

          return componentType.type === type
      })
  }

  public types: OpenGraphComponentType[] = [
    //            {type: OpenGraphTypes.Song, name: "Canción", icon: 'music_note'},
    //            {type: OpenGraphTypes.Album, name: "Album de música", icon: 'album'},
    //            {type: OpenGraphTypes.Playlist, name: "Lista de reproducción", icon: 'playlist_play'},
    //            {type: OpenGraphTypes.RadioStation, name: "Emisora de radio", icon: 'radio'},
    //            {type: OpenGraphTypes.Movie, name: "Película", icon: 'movie'},
    //            {type: OpenGraphTypes.Episode, name: 'Episodio', icon: 'slideshow'},
    //            {type: OpenGraphTypes.TVShow, name: 'Programa de TV', icon: 'tv'},
    {
      type: OpenGraphTypes.Article,
      name: 'Artículo',
      icon: 'forum',
      editor: 'opengraph-article-editor',
    },
    //            {type: OpenGraphTypes.Book, name: 'Libro', icon: 'book'},
    //            {type: OpenGraphTypes.Profile, name: 'Perfil', icon: 'account_box'},
    {
      type: OpenGraphTypes.Website,
      name: 'Sitio web',
      icon: 'public',
    },
    // {
    //   type: OpenGraphTypes.ProductItem,
    //   name: 'Producto',
    //   icon: 'shopping_cart',
    //   editor: 'opengraph-product-editor',
    // },
  ];

  /**
   * Objeto OpenGraph
   *
   * Permite acceder al objeto OpenGraph actualmente en edición o uno
   * vacío si no existe ninguno
   */
  get opengraph (): OpenGraph {
    if (!this.translation) {
      return new OpenGraph()
    }

    return this.translation.opengraph
  }

  /**
   * Actualiza una propiedad del objeto OpenGraph
   *
   * @param {string} property
   * @param {any} value
   */
  public update (property: string, value: any) {
    this.$store.commit('seo/metadata/current/translation/field/update', {
      field: `opengraph.${property}`,
      value,
    });
  }
}
